<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout row wrap justify-space-around>
        <v-flex xs10 sm10>
          <h1 style="font-family: Lato; text-align: center">
            <span style="margin-left: 10px; margin-right: 10px; color: white">
              <span class="capitalLetter">A</span>lerts
            </span>
          </h1>
          <hr style="margin-bottom: 30px; margin-left: 10px; margin-right: 10px">
        </v-flex>
        <v-flex xs11>
          <AlertsTable
            v-if="!isLoading"
            :alert-list="alertList"
            :search="search"
            :is-loading="isLoading"
            @popUpRequest2="popUp"
            @deleteRequest="deleteAlert"
          />
        </v-flex>
        <v-flex xs1>
          <v-alert :value="show" :type="alertType">{{dialogMessage}}</v-alert>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import AlertsTable from "../components/tables/AlertsTable.vue";
import axios from "axios";
import getSitePass from "../sitepass";

export default {
  name: "alerts",
  components: { AlertsTable },
  data: function() {
    return {
      alertList: [],
      isLoading: true,
      search: "",
      dialogMessage:"",
      alertType: "info",
      show: false,
    };
  },
  methods: {
    getMainStock() {
      axios
        .get(`${process.env.VUE_APP_backend_url}/getAllAlerts`, {
          params: {
            sitepass: getSitePass()
          }
        })
        .then(response => {
          this.alertList = response.data;
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    initialize() {
      this.getMainStock();
    },
    popUp(dialog) {
      this.dialogMessage = dialog.dialogMessage;
      this.alertType = dialog.alertType;
      this.show = true;
    },
    deleteAlert(submissionId) {
      const index = this.alertList.map(object => object.submissionId).indexOf(submissionId);
      if (index >= 0)
        this.alertList.splice(index,1)
    }
  },
  created() {
    this.initialize();
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/alertsView.vue